import { STYLE_OPTIONS } from 'src/constants';

const color = '#393939';
const colorGrey = '#7A7A7A';
const fontFamily = 'Roboto';

const tabEditStyle = (theme) => ({
  root: {},

  cardBox: {
    padding: '30px 170px 30px 0px',
    '&.cardBoxWithoutRightPadding': {
      paddingRight: 0,
    },
    '&.cardBoxFirst': {
      paddingTop: 0,
    },
    '&.cardBoxLast': {
      paddingBottom: 0,
    },

    [theme.breakpoints.down('lg')]: {
      paddingRight: 0,
    },

    [theme.breakpoints.down('md')]: {
      '& .MuiGrid-item + .MuiGrid-item': {
        paddingTop: 0,
      }
    },
  },

  groupLabel: {
    color,
    fontFamily,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '24px',
  },

  groupLabelText: {
    color: colorGrey,
    fontFamily,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    marginTop: 14,
    '&.mt0': {
      marginTop: 0,
    },
    '&.mt25': {
      marginTop: 25,
    },
    '&.mb20': {
      marginBottom: 20,
    },
    '&.semiBold': {
      fontWeight: 500,
    },
    '& .text-style-small-1': {
      fontSize: '14px',
    },
    '&.pt0, & .pt0': {
      paddingTop: 0,
    },
  },

  exampleHighlightsType1: {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 70,
    height: 35,
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    backgroundColor: STYLE_OPTIONS.COLOR_ACCOUNT_SETUP_FIELD_HIGHLIGHTS,
    [theme.breakpoints.down('sm')]: {
      '&.xs-block': {
        display: 'block',
        marginBottom: 5,
      }
    },
  },

  nbsp: {
    display: 'inline-block',
    width: '1em',
    [theme.breakpoints.down('sm')]: {
      '&.xs-none': {
        display: 'none',
      }
    },
  },

  labelTextUpload: {
    color,
    fontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    marginBottom: 16,
  },
});

export default tabEditStyle;
